import { Component } from '@angular/core';
import { _MSGTYPES, MSG_CONTENT_TYPE } from '../../shared/constant/msgType';
import { URLS } from '../../shared/constant/interface';
import { isArray, isJsonString } from '../../shared/utils/common';
import { TplAuditData } from '../../msg-interface/data-model';
import { MsgTemplateAudit } from '../../msg-interface/msg-template-audit';

@Component({
  selector: 'icc-tiktok-tpl-audit',
  templateUrl: './tiktok-tpl-audit.component.html',
  styleUrls: ['./tiktok-tpl-audit.component.less'],
})
export class TiktokTplAuditComponent implements MsgTemplateAudit {
  constructor() {}
  SCENE = 'icc-msg-tpl-audit';
  type = _MSGTYPES.MT.TIKTOK.type;
  // 模板列表
  tplList: any;
  // 数据操作状态
  operate = { normal: 0, add: 1, delete: 2, update: 3 };
  // 是否打开修改标记
  openEffect: boolean;
  tableConfig = {
    header: ['类型', '条件名称', '条件描述'],
    attr: [
      {
        name: 'conType',
        type: 'object',
      },
      {
        name: 'name',
        type: 'object',
      },
      {
        name: 'desc',
        type: 'array',
      },
    ],
  };
  // 逻辑关系
  relationTypes = {
    1: '"与"关系',
    2: '"或"关系',
  };
  contentType = MSG_CONTENT_TYPE;
  fileBaseUrl = URLS.attachment.url + '?';

  useTmplMethod: number;

  /* 赋值 */
  setData(data: TplAuditData[], useTmplMethod: number) {
    this.tplList = data;
    this.useTmplMethod = useTmplMethod;
    this.tplList.forEach((item: any) => {
      const content = item.map.content;
      const title = item.map.title;
      const mediaList = item.map.mediaList;
      const updateType = content.type;
      title.type = updateType;
      mediaList.type = updateType;
      item.map.realContentType = {
        type: updateType,
      };

      let valueObj;
      let oldValueObj;
      if (isJsonString(content.value)) {
        valueObj = JSON.parse(content.value);
        item.map.realContentType.value = valueObj ? valueObj.contentType : '';
        if (valueObj instanceof Array && valueObj.length) {
          valueObj = valueObj[0];
        }
      }
      if (isJsonString(content.oldValue)) {
        oldValueObj = JSON.parse(content.oldValue);
        item.map.realContentType.oldValue = oldValueObj ? oldValueObj.contentType : '';
        if (oldValueObj instanceof Array && oldValueObj.length) {
          oldValueObj = oldValueObj[0];
        }
      }
      if ((updateType === this.operate.delete || updateType === this.operate.update) && oldValueObj) {
        title.oldValue = oldValueObj.title;
        mediaList.oldValue = oldValueObj;
        oldValueObj.mediaList.forEach(_item => {
          _item.url = this.fileBaseUrl + _item.url;
        });
      }
      if (updateType !== this.operate.delete && valueObj) {
        title.value = valueObj.title;
        mediaList.value = valueObj;
        valueObj.mediaList.forEach(_item => {
          _item.url = this.fileBaseUrl + _item.url;
        });
      }
      // 当content为修改状态，对其中的字段逐一判断
      if (updateType === this.operate.update) {
        title.type = title.value === title.oldValue ? this.operate.normal : this.operate.update;
        mediaList.type = JSON.stringify(valueObj.mediaList) === JSON.stringify(oldValueObj.mediaList) ? this.operate.normal : this.operate.update;
        item.map.realContentType.type = item.map.realContentType.value === item.map.realContentType.oldValue ? this.operate.normal : this.operate.update;
      }
      item.map.realContentType.name = item.map.realContentType.value === this.contentType.IMAGE ? '图片' : item.map.realContentType.value === this.contentType.VIDEO ? '视频' : '';
    });
    console.log('after.tplList :>> ', this.tplList);
  }
  /* 切换展示状态 */
  switchDisplayStatus(isOpenEffect: boolean) {
    this.openEffect = isOpenEffect;
  }

  // 判断执行条件中的有用的执行条件数量是否大于一
  isRealConditionsOverOne(list) {
    if (list && isArray(list)) {
      let temp = list.filter(item => {
        return item.type === 1 || item.type === 0;
      });
      if (temp && temp.length > 1) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }
}
